import { render, staticRenderFns } from "./hotRecommend.vue?vue&type=template&id=385a59f7&"
import script from "./hotRecommend.vue?vue&type=script&lang=js&"
export * from "./hotRecommend.vue?vue&type=script&lang=js&"
import style0 from "./common.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports